<template>
    <nav v-show="!hidden" class="border-stroke-1 bg-bg z-5 border-t-1">
        <div class="mx-auto flex h-full max-w-[768px] items-start justify-between px-4">
            <menu-item :title="$t('nav.home')" name="home">
                <svg width="33" height="32" viewBox="0 0 33 32">
                    <path
                        d="M28.75 11.7305V28H4.75V11.7305L16.75 3.73047L28.75 11.7305ZM7.41667 13.1576V25.3333H11.8607V15.8516H21.6393V25.3333H26.0833V13.1576L16.75 6.9349L7.41667 13.1576ZM14.5273 25.3333H18.9727V18.5182H14.5273V25.3333Z"
                    />
                </svg>
            </menu-item>

            <menu-item :title="$t('nav.setups')" name="setups">
                <svg width="33" height="32" viewBox="0 0 33 32">
                    <path
                        d="M29.1686 13.6979L22.7272 16.918L20.5293 25.7161L3.99023 28.2604L6.53451 11.7214L15.3314 9.52214L18.5514 3.08203L29.1686 13.6979ZM8.89909 13.8789L7.52018 22.8437L11.6986 18.6667L11.041 18.0091L12.9264 16.1237L16.127 19.3229L14.2415 21.2096L13.584 20.5521L9.4056 24.7292L18.3704 23.3503L20.1074 16.4089L15.8405 12.1419L8.89909 13.8789ZM17.873 10.4036L21.847 14.3776L24.666 12.9674L19.2819 7.58333L17.873 10.4036Z"
                    />
                </svg>
            </menu-item>

            <a class="h-full !w-[66px]" data-testid="nav-new-game" @click="startGame('501')">
                <svg
                    class="mx-auto -mt-[8px] transition-all"
                    viewBox="0 0 73.5 56"
                    :class="{ 'brightness-50': matchStarting }"
                >
                    <path d="M5.98,9L13.98,0h48.02l7.99,9h.01H5.98Z" style="fill: #141414" />
                    <path
                        d="M53.79,8.5l7.71,7.71v31.59l-7.71,7.71h-31.59l-7.71-7.71v-31.59l7.71-7.71h31.59Z"
                        style="fill: #e73737; stroke: #9a191c"
                    />
                    <path
                        d="M39.33,24v6.67h6.67v2.67h-6.67v6.67h-2.67v-6.67h-6.67v-2.67h6.67v-6.67h2.67Z"
                        style="fill: #fff"
                    />
                    <path
                        d="M0,8.5h6.2S14.19.52,14.19.52l47.61-.02,8,8h3.7"
                        style="fill: none; stroke: #2b2b2b"
                    />
                </svg>
            </a>

            <menu-item :title="$t('nav.statistics')" name="statistics">
                <svg
                    width="33"
                    height="32"
                    viewBox="0 0 26 22"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto h-full w-full"
                >
                    <path
                        d="M2.66667 0V10.9688L9.3737 4.82161L14.069 9.51693L20.5078 4H17.3333V1.33333H25.3333V8.66667H22.6667V5.65885L13.9297 13.1497L9.29297 8.51172L2.66667 14.5859V19.3333H25.3333V22H0V0H2.66667Z"
                    />
                </svg>
            </menu-item>

            <menu-item :title="$t('nav.profile')" name="profile">
                <svg width="33" height="32" viewBox="0 0 33 32">
                    <path
                        d="M26.9173 21.333V26.6663L24.2507 27.9997V22.6663H8.25065V27.9997L5.58398 26.6663V21.333L6.91732 19.9997H25.584L26.9173 21.333ZM20.2507 11.9997C20.2507 9.79053 18.4598 7.99967 16.2507 7.99967C14.0415 7.99967 12.2507 9.79053 12.2507 11.9997C12.2507 14.2088 14.0415 15.9997 16.2507 15.9997C18.4598 15.9997 20.2507 14.2088 20.2507 11.9997ZM22.9173 11.9997C22.9173 15.6816 19.9325 18.6663 16.2507 18.6663C12.5688 18.6663 9.58398 15.6816 9.58398 11.9997C9.58398 8.31778 12.5688 5.33301 16.2507 5.33301C19.9325 5.33301 22.9173 8.31778 22.9173 11.9997Z"
                    />
                </svg>
            </menu-item>
        </div>
    </nav>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import { useMatchStore } from '@/stores/match.js'
import MenuItem from './Item.vue'

export default {
    name: 'NavigationMenu',
    components: {
        MenuItem,
    },
    props: {
        hidden: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            matchStarting: false,
        }
    },
    computed: {
        ...mapStores(useAuthStore, useMatchStore),
    },
    methods: {
        startGame(type) {
            try {
                this.matchStarting = true
                this.matchStore.selectMatchType(type, this.authStore, this.$router, this.$toast)
            } catch (error) {
                console.error('Error starting match:', error)
            } finally {
                this.matchStarting = false
            }
        },
    },
}
</script>
